/* eslint-disable react/destructuring-assignment */
import React, { Component } from 'react';
import { Modal } from 'semantic-ui-react';
//import Loader from '../Loader/Loader';
import api from '../../api';
import WithRouter from '../Extensions/WithRouter';

class DeleteProjectModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpenMDP: props.isOpenMDP,
    };
    this.closeDeleteProjectModal = this.closeDeleteProjectModal.bind(this);
    this.deleteProject = this.deleteProject.bind(this);
    this.deleteUser = this.deleteUser.bind(this);
  }

  componentDidMount() {}

  componentDidUpdate(prevProps) {
    const { isOpenMDP } = this.props;

    if (prevProps.isOpenMDP !== isOpenMDP) {
      this.setState({
        isOpenMDP,
      });
    }
  }

  deleteProject() {
    const pidArr = this.props.data;
    if (this.props.status) {
      api.deleteProject(pidArr).then(() => {
        this.closeDeleteProjectModal();
        if (this.props.completeCallback) this.props.completeCallback(200);
      });
    } else {
      api
        .deletSProject(
          { project_ids: pidArr, }
        )
        .then((response) => {
          if (response.status === 200) {
            this.closeDeleteProjectModal();
            if (this.props.completeCallback) {
              this.props.completeCallback(200);
            }
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }

  deleteUser() {
    const uidArr = this.props.data;
    if (this.props.status) {
      api.deleteUser(uidArr).then(() => {
        this.closeDeleteProjectModal();
        if (this.props.completeCallback) this.props.completeCallback(200);
      });
    } else {
      api
        .deletSUser(
          { user_ids: uidArr, }
        )
        .then((response) => {
          if (response.status === 200) {
            this.closeDeleteProjectModal();
            if (this.props.completeCallback) {
              this.props.completeCallback(200);
            }
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }

  closeDeleteProjectModal() {
    this.setState({
      isOpenMDP: false,
    });
    this.props.closeModal();
  }

  render() {
    const { location, translate } = this.props;
    const path = location.pathname ? location.pathname : location;

    return (
      <Modal open={this.state.isOpenMDP} onClose={this.closeDeleteProjectModal}>
        <div className="modal_popup_wrap confirm_wrap">
          <div className="modal_popup_box confirm_box">
            <div className="modal_popup confirm">
              <h2 className="title">{translate('modal.title.attention')}</h2>
              <p className="text">
                {path.indexOf('user') > -1
                  ? translate('modal.message.delete_user')
                  : translate('modal.message.delete_project')}
              </p>
              <p className="small_text">
                {path.indexOf('user') > -1
                  ? translate('modal.message.delete_user_small')
                  : translate('modal.message.delete_project_small')}
              </p>
              <div className="button_wrap">
                <a
                  className="left_button"
                  onClick={this.closeDeleteProjectModal}
                  onKeyUp={this.closeDeleteProjectModal}
                >
                  {translate('modal.button.cancel')}
                </a>
                <a
                  className="right_button"
                  onClick={
                    path.indexOf('user') > -1 ? this.deleteUser : this.deleteProject
                  }
                  onKeyUp={
                    path.indexOf('user') > -1 ? this.deleteUser : this.deleteProject
                  }
                >
                  {translate('modal.button.delete')}
                </a>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    );
  }
}

export default WithRouter(DeleteProjectModal);
